import { Model } from 'json-api-models';

import profileOptions from '../../../profile-options.json';
import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class User extends Model<Schemas['users'], Models> {
    hasAbility(ability: string): boolean {
        return this.abilities?.includes(ability) || false;
    }

    get createdAtDate() {
        return nullableDate(this.createdAt);
    }

    get lastSeenAtDate() {
        return nullableDate(this.lastSeenAt);
    }

    get agreementSignedAtDate() {
        return nullableDate(this.agreementSignedAt);
    }

    get institutionName(): string | null {
        return this.institution?.name || this.institutionOther;
    }

    get isStudent() {
        return this.training?.includes('Student');
    }

    get info(): string {
        const specialties = (this.specialties || []).filter(Boolean);
        const specialtyPrefix =
            this.training &&
            specialties.length &&
            ['Registrar', 'Fellow', 'Consultant'].includes(this.training)
                ? `${specialties.join(' / ')} `
                : '';

        return [
            this.position ||
                (this.training === 'Other' ? this.industry : null) ||
                specialtyPrefix + (this.training || ''),
            this.institutionName,
        ]
            .filter(Boolean)
            .join(', ');
    }

    get adminRoute() {
        return {
            name: `users.profile`,
            params: { id: this.id },
        };
    }
}

export const competentAuthorityCountries = ['AU', 'GB', 'CA', 'US', 'NZ', 'IE'];

export const sourceOptions = [
    'Friend or Colleague',
    'Student Society',
    'University Faculty',
    'Workplace',
    'Social Media',
    'Google Search',
    'Australian Medical Council',
    'AMSA Convention',
];

export function sourceOptionsForUser(user: Pick<User, 'isStudent'>): string[] {
    return sourceOptions.filter((option) =>
        user.isStudent
            ? option !== 'Workplace'
            : !['Student Society', 'University Faculty'].includes(option),
    );
}

export const trainingOptions = profileOptions.training;

export const specialtyOptions = [
    { value: null, label: 'Not sure yet' },
    ...profileOptions.specialties.map((o) =>
        Array.isArray(o) ? { value: o[0], label: o[0], synonyms: o[1] } : o,
    ),
];

export const industryOptions = [
    'Audiology',
    'Dentistry',
    'Dietetics',
    'Exercise Physiology',
    'Health/Medical Sciences',
    'Medicine',
    'Nursing',
    'Occupational Therapy',
    'Optometry',
    'Paramedic',
    'Pharmacy',
    'Physiotherapy',
    'Podiatry',
    'Psychology',
    'Radiography',
    'Sonography',
    'Speech Pathology',
];
